import { Component, OnInit,Input, SimpleChanges } from '@angular/core';

import {Documento} from 'src/app/shared/models/documentos/documentos.interface';
import {DocumentosService} from 'src/app/pages/services/documentos.service';

@Component({
  selector: 'app-lista-implementossU',
  templateUrl: './lista-implementossU.component.html',
  styleUrls: ['./lista-implementossU.component.css']
})
export class ListaImplementossUComponent implements OnInit {
  @Input() fk_trabajador:number=0;

  documentos:Documento[] = [];
 
  constructor(
    private documentoService: DocumentosService
  ) { }

  ngOnInit(): void {
   
    this.documentoService.traerDocsImplementosU(this.fk_trabajador).subscribe(
      (res) => {
          this.documentos = res.data;
        //console.log(this.documentos);
      }
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    

   

      this.documentos=[]
      this.documentoService.traerDocsImplementosU(this.fk_trabajador).subscribe(
        (res) => {

          this.documentos = res.data;
          //console.log(this.documentos);
        }
      );
    
  

}

}
